import React from 'react'
import { useSelector } from 'react-redux'

import CentreBlockModal from './accountBlock/CentreBlockModal'
import DemoModalManager from './demoOnBoarding/DemoModalManajer'
import SuprademoTourModal from './SupademoTourModal'

const OnBoardingModals = () => {
  const centreDetail = useSelector((state) => state.centres.centreProfile)
  const { blockedCentre } = useSelector((state) => state.centres)
  const isDemoStatus = centreDetail?.creationDate && centreDetail.status === 'demo'
  const isBlockedStatus = blockedCentre?.status

  return (
    <>
      {isDemoStatus && <DemoModalManager centreCreationDate={centreDetail.creationDate} />}
      {isDemoStatus && <SuprademoTourModal />}
      {isBlockedStatus && <CentreBlockModal centreDetail={centreDetail} />}
    </>
  )
}

export default OnBoardingModals
